const isDev = window.location.hostname.includes("localhost");

function initAccordions() {
  const accordions = document.querySelectorAll<HTMLElement>(".accordion");

  if (accordions.length < 1) return;
  accordions.forEach((accordion) => {
    const button = accordion.querySelector(".accordion-toggle") as HTMLButtonElement;
    button && button.addEventListener("click", handleAccordionClick);
    const accordionBody = accordion.querySelector(".accordion-body") as HTMLElement;
    accordionBody && accordionBody.addEventListener("transitionend", handleTransitionEnd);
  });
}

// only add the hidden attribute to the accordion body content after accordion has transitioned
function handleTransitionEnd(event: TransitionEvent) {
  const target = event.target as HTMLElement;
  const accordionBodyContent = target.querySelector(".accordion-body-content");
  const accordionIsClosing = !target.closest(".accordion")?.classList.contains("accordion--open");

  if (accordionBodyContent && accordionIsClosing) {
    accordionBodyContent.setAttribute("hidden", "");
  }
}

function closeAllAccordions() {
  const accordions = document.querySelectorAll(".accordion");
  accordions.forEach((accordion) => {
    const button = accordion.querySelector(".accordion-toggle") as HTMLButtonElement;
    const accordionBody = accordion.querySelector(".accordion-body-content") as HTMLElement;
    accordion.classList.remove("accordion--open");
    button.setAttribute("aria-expanded", "false");
    accordionBody.setAttribute("hidden", "");

    // check if there're checkboxes in the accordion, if so, uncheck them
    const checkboxes = accordion.querySelectorAll(
      'input[type="checkbox"]:checked'
    ) as NodeListOf<HTMLInputElement>;
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  });
}

function handleAccordionClick(event: MouseEvent) {
  event.stopPropagation();
  event.preventDefault();

  const target = event.target as HTMLElement;
  const button = target.closest(".accordion-toggle") as HTMLButtonElement;
  const accordionIsOpen = button?.getAttribute("aria-expanded") === "true";
  const accordion = button.closest(".accordion");
  const accordionBody = accordion?.querySelector(".accordion-body-content");
  const spanText = button.querySelector("span:not([class*='iconBg-'])");
  const isTopic = button?.classList.contains("topicBrowser-topic");
  if (isTopic) {
    closeAllAccordions();
  }

  if (accordionIsOpen) {
    accordion?.classList.remove("accordion--open");
    if (spanText && !isTopic) {
      spanText.textContent = "Show";
    }
  } else {
    accordionBody?.removeAttribute("hidden");
    accordion?.classList.add("accordion--open");
    if (spanText && !isTopic) {
      spanText.textContent = "Hide";
      if (!isDev) {
        gtag("event", "page_view", { page_location: target.getAttribute("data-target") });
      }
    }
  }
  button.setAttribute("aria-expanded", accordionIsOpen ? "false" : "true");
}

initAccordions();

// Make the header clickable to open the accordion in Result Cards
const resultCards = document.querySelectorAll(".resultCard");
resultCards.forEach((resultCard) => {
  const header = resultCard.querySelector(".resultCard-header > h2, .resultCard-header > .h2");
  header?.addEventListener("click", (event) => {
    const button = resultCard.querySelector(".accordion-toggle") as HTMLButtonElement;
    button.click();
  });
});
